/**
 * 依美容／住宿開關決定首頁是否應導向其他路由。
 * @param {Object} getters - Vuex getters
 * @returns {Object|null} route location 或 null（維持首頁）
 */
export function resolveHomeRedirect(getters) {
  if (getters['merchant/isSiteEnabled']) return null
  if (getters['merchant/hasHotelModule']) {
    return { name: 'hotel-price', replace: true }
  }
  return { name: 'service-unavailable', replace: true }
}
